import { AgeGroup } from '@/shared/api/protocol-ts/api/core/svc_patient_pb';

export const AGE_GROUP_TO_LABEL: Record<string, string> = {
  [AgeGroup.PatientListStreamAgeGroup_Adults.toString()]: 'adults',
  [AgeGroup.PatientListStreamAgeGroup_Children.toString()]: 'children',
};
